<template>
  <div class="d-flex align-items-stretch">
    <ib-tooltip
      popper-class="center small"
      :content="$t('previousStep')"
    >
      <ib-button
        class="next-back-btn"
        :disabled="isBackDisabled || disabled"
        variant="white"
        @click="$emit('navigate-back')"
      >
        <i class="ib-icon ib-icon-back-2" />
      </ib-button>
    </ib-tooltip>
    <ib-tooltip
      popper-class="center small"
      :content="$t('nextStep')"
    >
      <ib-button
        class="next-back-btn ml-2"
        :disabled="isNextDisabled || disabled"
        variant="white"
        @click="$emit('navigate-next')"
      >
        <i class="ib-icon ib-icon-forward-2" />
      </ib-button>
    </ib-tooltip>
  </div>
</template>

<script>
export default {
  name: 'PreviousNextButtons',

  inject: ['getBack', 'getNext'],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    back () {
      return this.getBack()
    },
    next () {
      return this.getNext()
    },

    isBackDisabled () {
      return !!this.back.disabled
    },

    isNextDisabled () {
      return !!this.next.disabled || !this.next.title
    }
  }
}
</script>

<style scoped lang="scss">

i {
  font-size: 25px;
  color: $color-navy;
  opacity: 0.6;
}

.next-back-btn {
  ::v-deep {
    padding: 10px;
  }
}
</style>
